import React, { useEffect } from "react";
import {
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import Provider from "../Provider";
import { useStyle } from "../styles";
import { useAuth } from "../../../services/AuthContext";
import { ColorButton } from "../../../services/helper";

function FormFour({ Button }) {
  const classes = useStyle();

  const { user } = useAuth();

  useEffect(() => {
    setFullName(user?.name);
    setMobile_Number(user?.mobile_number);
  }, [user]);

  const {
    errorsFormOne,
    setFullName,
    fullName,
    setMobile_Number,
    mobile_number,
    fatherName,
    setFatherName,
    fatherNo,
    setFatherNo,
    emergencyNo,
    setEmergencyNo,
    relationName,
    setRelationName,
    relationType,
    handleRelationType,
    fillRelationsType,
    handleSubmitFormFour,
  } = Provider();

  return (
    <>
      <div className={classes.mainContainer}>
        <div className={classes.box}>
          <div className={classes.heading}>Driver Emergency Contact</div>
          <Grid container spacing={1} style={{ marginTop: 5 }}>
            <Grid item xs={6}>
              <TextField
                fullWidth
                onChange={(event) => setEmergencyNo(event.target.value)}
                label="Emergency Number"
                variant="outlined"
                value={emergencyNo}
                inputProps={{ maxLength: 10 }}
                InputProps={{
                  style: { fontFamily: "Poppins, sans-serif" },
                }}
                InputLabelProps={{
                  style: { fontFamily: "Poppins, sans-serif" },
                }}
                error={!!errorsFormOne.emergencyNo}
                helperText={errorsFormOne.emergencyNo}
              />
            </Grid>

            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ fontFamily: "Poppins" }}
                >
                  Relation Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={relationType}
                  label="Relation Type"
                  onChange={handleRelationType}
                  sx={{ fontFamily: "Poppins" }}
                  error={!!errorsFormOne.relationType}
                  helperText={errorsFormOne.relationType}
                >
                  <MenuItem value={"Choose Type..."}>Choose Type...</MenuItem>
                  {fillRelationsType()}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <div className={classes.note}>
                Note: Ensure that this number is used for sending the
                verification code.
              </div>
            </Grid>
            <Grid item xs={12}>
              <ColorButton onClick={handleSubmitFormFour} variant="contained">
                Submit
              </ColorButton>
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default FormFour;
